<template>
  <div class="table">
    <div class="container">
      <el-form :model="detailForm" ref="detailForm" :rules="rules" label-width="120px">
        <el-form-item label="评价月">
          <el-input v-model="detailForm.month" disabled style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="指标类型">
          <el-input v-model="detailForm.factorType" disabled style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="Facility名称">
          <el-input v-model="detailForm.facilityName" disabled style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <ic-select disabled table="TT_QSPI_FACILITY_FACTOR_SCORE" field="STATUS" v-model="detailForm.status" placeholder="请选择" style="width:100%"></ic-select>
        </el-form-item>
        <el-form-item label="截止日期">
          <el-input v-model="detailForm.deadline" disabled style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="审核评级" prop="auditGrade" v-if="factorType==='SWA'">
          <ic-select v-model="detailForm.auditGrade" :disabled="isDisabled||!isCanAudit" @change="auditGradeChange" table="TT_QSPI_FACILITY_FACTOR_SCORE" field="AUDIT_GRADE" placeholder="请选择" style="width:100%"></ic-select>
        </el-form-item>
        <el-form-item label="等级" prop="grade" :class="factorType!=='AAA'&&factorType!=='QBR'&&factorType!=='MSV'&&factorType!=='SWA'&&factorType!=='SQMS'&&factorType!=='SENSORY'&&factorType!=='DQMP'?'is-required':''">
          <el-select v-model="detailForm.grade" style="width:100%" disabled v-if="factorType==='SQMS'">
            <el-option :key="index" v-for="(item,index) in gradeOptions" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <ic-select v-else :disabled="isDisabled||!isCanAudit" table="TT_QSPI_FACILITY_FACTOR_SCORE" field="GRADE" v-model="detailForm.grade" placeholder="请选择" style="width:100%"></ic-select>
        </el-form-item>
        <el-form-item label="分数" prop="score" v-if="factorType=='SQMS'">
          <el-input v-model="detailForm.score" style="width:100%" @change="scoreChange" :disabled="isDisabled||!isCanAudit"></el-input>
        </el-form-item>
        <el-form-item label="Comment">
          <el-input type="textarea" :disabled="isDisabled||!isCanAudit" v-model="detailForm.remark" :autosize="{ minRows: 4, maxRows: 8}" maxlength="1000" show-word-limit style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="Attachment List" v-if="factorType=='SQMS'&&isCanAudit">
          <el-upload :disabled="isDisabled" :show-file-list="false" :file-list="fileList" ref="upload" :headers="header" action="#" :on-change="handleFileChange" :before-remove="handleFileRemove" :before-upload="beforeUpload" :on-success="uploadSuccess" :auto-upload="false" :multiple="true" style="display:inline-block">
            <!-- <el-button type="primary">{{$t("common.upload")}}</el-button> -->
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
          <el-button type="primary" @click="submitFileForm" style="display:inline-block;margin-left:10px;">确定</el-button>
        </el-form-item>
        <el-row v-if="factorType==='SQMS'">
          <div v-for="(file,index) in fileList" :key="index" style="width:calc(100% - 120px);line-height: 40px;margin-left:120px;">
            <el-row>
              <el-col :span="21">
                <el-tooltip class="item" effect="dark" :content="file.documentName" placement="top">
                  <el-link type="primary" @click="downloadFile(file)" class="other_link" style="width:90%;overflow:hidden">{{file.documentName}}</el-link>
                </el-tooltip>
              </el-col>
              <el-col :span="3" v-if="isCanAudit">
                <el-button @click="delFile(file,index)" type="danger" icon="el-icon-delete" circle class="delCircle"></el-button>
              </el-col>
            </el-row>
          </div>
        </el-row>
        <el-row type="flex" justify="center" v-if="!isDisabled&&isCanAudit">
          <el-button type="primary" @click="onSave" v-if="detailForm.status!=='SCORED'" v-acl="QSPI_MSV_SAVE,QSPI_SWA_SAVE,QSPI_SQMS_SAVE,QSPI_GOVTCERT_SAVE,QSPI_SPECCOMP_SAVE,QSPI_COA_SAVE,QSPI_REGCOMP_SAVE,QSPI_GOVTPLANT_SAVE,QSPI_OTHSTOCKRECOVER_SAVE,QSPI_PRDFEEDBACK_SAVE,QSPI_SENSORY_SAVE,QSPI_OTHQIP_SAVE,QSPI_ANTICHICK_SAVE,QSPI_OTHQBR_SAVE">保存</el-button>
          <el-button type="primary" @click="onSubmit" v-acl="QSPI_MSV_SUBMIT,QSPI_SWA_SUBMIT,QSPI_SQMS_SUBMIT,QSPI_GOVTCERT_SUBMIT,QSPI_SPECCOMP_SUBMIT,QSPI_COA_SUBMIT,QSPI_REGCOMP_SUBMIT,QSPI_GOVTPLANT_SUBMIT,QSPI_OTHSTOCKRECOVER_SUBMIT,QSPI_PRDFEEDBACK_SUBMIT,QSPI_SENSORY_SUBMIT,QSPI_OTHQIP_SUBMIT,QSPI_ANTICHICK_SUBMIT,QSPI_OTHQBR_SUBMIT">提交</el-button>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import otherApi from "@/api/other/index";
import IcSelect from "@/components/common/icSelect";
import commonConstatns from "@/constants/commonConstants";
import commonFun from "@/utils/commonFun";
import QBRApi from "@/api/QBR/index";
import { fileService } from "@/api/common/file-utils";
export default {
  components: {
    IcSelect,
  },
  props: [
    "factorType",
    "ttQspiFacilityFactorScoreId",
    "isCanAudit",
    "editForm",
  ],
  data() {
    var validateScore = (rule, value, callback) => {
      console.log("factorType", this.factorType);
      var reg = /^(0|\+?[1-9][0-9]*)$/;
      if (value && !reg.test(value)) {
        callback(new Error("分数只能输入大于等于0的整数"));
      } else {
        callback();
      }
    };
    var validateGrade = (rule, value, callback) => {
      console.log("value", value);
      if (
        this.factorType !== "AAA" &&
        this.factorType !== "QBR" &&
        this.factorType !== "MSV" &&
        this.factorType !== "SWA" &&
        this.factorType !== "SQMS" &&
        this.factorType !== "SENSORY" &&
        !value
      ) {
        callback(new Error("请选择等级"));
      } else {
        callback();
      }
    };
    return {
      isDisabled: false,
      header: {
        "x-access-token": localStorage.getItem("token"),
      },
      detailForm: {
        month: "",
        factorType: "",
        facilityName: "",
        status: "",
        deadline: "",
        auditGrade: "",
        grade: null,
        score: "",
        remark: "",
      },
      levelList: [],
      fileList: [],
      upload: {
        fileList: [],
      },
      gradeOptions: [
        {
          label: "A",
          value: "A",
        },
        {
          label: "B",
          value: "B",
        },
        {
          label: "C",
          value: "C",
        },
        {
          label: "F",
          value: "D",
        },
      ],
      ms_Permission: JSON.parse(localStorage.getItem("ms_Permission")),
      rules: {
        grade: [{ validator: validateGrade, trigger: "change" }],
        score: [{ validator: validateScore, trigger: "blur" }],
      },
    };
  },
  watch: {
    editForm: {
      handler(newV, oldV) {
        console.log("3333", newV);
        if (newV.factorType) {
          this.detailForm = newV;
          var ms_Permission = JSON.parse(localStorage.getItem("ms_Permission"));
          console.log("ms_Permission", ms_Permission);
          // 如果是Other权限,factorType是SQMS/SPECCOMPLIANCE/REGCOMPLIANCE/GOVTPLANTAUDIT并且在截止日期之内并且是待评分状态,则可以编辑comments和附件,提交和保存
          switch (newV.factorType) {
            case "MSV":
              if (ms_Permission.indexOf("QSPI_MSV_OWNER") !== -1) {
                this.isDisabled = false;
              } else if (ms_Permission.indexOf("QSPI_MSV_SAVE") !== -1) {
                this.isDisabled = true;
              }
              break;
            case "SWA":
              if (ms_Permission.indexOf("QSPI_SWA_OWNER") !== -1) {
                this.isDisabled = false;
              } else if (ms_Permission.indexOf("QSPI_SWA_SAVE") !== -1) {
                this.isDisabled = true;
              }
              break;
            case "SQMS":
              if (ms_Permission.indexOf("QSPI_SQMS_OWNER") !== -1) {
                this.isDisabled = false;
              } else if (ms_Permission.indexOf("QSPI_SQMS_SAVE") !== -1) {
                var aaa = Date.parse(new Date());
                var bbb = Date.parse(new Date(newV.deadline));
                if (bbb && aaa < bbb && newV.status === "UNSCORED") {
                  this.isDisabled = false;
                } else {
                  this.isDisabled = true;
                }
              }
              break;
            case "GOVT_CERT":
              if (ms_Permission.indexOf("QSPI_GOVTCERT_OWNER") !== -1) {
                this.isDisabled = false;
              } else if (ms_Permission.indexOf("QSPI_GOVTCERT_SAVE") !== -1) {
                this.isDisabled = true;
              }
              break;
            case "SPEC_COMPLIANCE":
              if (ms_Permission.indexOf("QSPI_SPECCOMP_OWNER") !== -1) {
                this.isDisabled = false;
              } else if (ms_Permission.indexOf("QSPI_SPECCOMP_SAVE") !== -1) {
                var aaa = Date.parse(new Date());
                var bbb = Date.parse(new Date(newV.deadline));
                if (bbb && aaa < bbb && newV.status === "UNSCORED") {
                  this.isDisabled = false;
                } else {
                  this.isDisabled = true;
                }
              }
              break;
            case "COA":
              if (ms_Permission.indexOf("QSPI_COA_OWNER") !== -1) {
                this.isDisabled = false;
              } else if (ms_Permission.indexOf("QSPI_COA_SAVE") !== -1) {
                this.isDisabled = true;
              }
              break;
            case "REG_COMPLIANCE":
              if (ms_Permission.indexOf("QSPI_REGCOMP_OWNER") !== -1) {
                this.isDisabled = false;
              } else if (ms_Permission.indexOf("QSPI_REGCOMP_SAVE") !== -1) {
                var aaa = Date.parse(new Date());
                var bbb = Date.parse(new Date(newV.deadline));
                if (bbb && aaa < bbb && newV.status === "UNSCORED") {
                  this.isDisabled = false;
                } else {
                  this.isDisabled = true;
                }
              }
              break;
            case "GOVT_PLANT_AUDIT":
              if (ms_Permission.indexOf("QSPI_GOVTPLANT_OWNER") !== -1) {
                this.isDisabled = false;
              } else if (ms_Permission.indexOf("QSPI_GOVTPLANT_SAVE") !== -1) {
                var aaa = Date.parse(new Date());
                console.log("aaa", aaa);
                console.log("bbb", bbb);
                var bbb = Date.parse(new Date(newV.deadline));
                console.log("bbb", bbb);
                console.log("aaa < bbb", aaa < bbb);
                console.log("status", newV.status);
                if (bbb && aaa < bbb && newV.status === "UNSCORED") {
                  this.isDisabled = false;
                } else {
                  this.isDisabled = true;
                }
              }
              break;
            case "STOCK_RECOVERY":
              if (ms_Permission.indexOf("QSPI_OTHSTOCKRECOVER_OWNER") !== -1) {
                this.isDisabled = false;
              } else if (
                ms_Permission.indexOf("QSPI_OTHSTOCKRECOVER_SAVE") !== -1
              ) {
                this.isDisabled = true;
              }
              break;
            case "PRODUCT_FEEDBACK":
              if (ms_Permission.indexOf("QSPI_PRDFEEDBACK_OWNER") !== -1) {
                this.isDisabled = false;
              } else if (
                ms_Permission.indexOf("QSPI_PRDFEEDBACK_SAVE") !== -1
              ) {
                this.isDisabled = true;
              }
              break;
            case "SENSORY":
              if (ms_Permission.indexOf("QSPI_SENSORY_OWNER") !== -1) {
                this.isDisabled = false;
              } else if (ms_Permission.indexOf("QSPI_SENSORY_SAVE") !== -1) {
                this.isDisabled = true;
              }
              break;
            case "QIP":
              if (ms_Permission.indexOf("QSPI_OTHQIP_OWNER") !== -1) {
                this.isDisabled = false;
              } else if (ms_Permission.indexOf("QSPI_OTHQIP_SAVE") !== -1) {
                this.isDisabled = true;
              }
              break;
            case "QBR":
              if (ms_Permission.indexOf("QSPI_OTHQBR_OWNER") !== -1) {
                this.isDisabled = false;
              } else if (ms_Permission.indexOf("QSPI_OTHQBR_SAVE") !== -1) {
                this.isDisabled = true;
              }
              break;
            case "ANTIBIOTIC_CHICKEN":
              if (ms_Permission.indexOf("QSPI_ANTICHICK_OWNER") !== -1) {
                this.isDisabled = false;
              } else if (ms_Permission.indexOf("QSPI_ANTICHICK_SAVE") !== -1) {
                this.isDisabled = true;
              }
              break;
          }
          console.log("isDisabled", this.isDisabled);
        }
      },
      deep: true,
      immediate: true,
    },
    ttQspiFacilityFactorScoreId: {
      handler(newV, oldV) {
        console.log("ttQspiFacilityFactorScoreId", newV);
        if (this.factorType === "SQMS") {
          this.getFileLists();
        }
      },
      immediate: true,
    },
  },
  computed: {
    fileUploadUrl() {
      if (commonFun.isNotEmpty(this.ttQspiFacilityFactorScoreId)) {
        return (
          commonConstatns.fileUploadUrl +
          `/${this.factorType}/${this.ttQspiFacilityFactorScoreId}`
        );
      }
    },
  },
  created() {
    // if (this.factorType === 'SQMS') {
    //   this.getFileLists()
    // }
  },
  methods: {
    auditGradeChange(val) {
      console.log("val", val);
      this.detailForm.grade = "";
      this.detailForm.auditGrade = val;
      if (val === "Red") {
        this.detailForm.grade = "C";
      } else if (val === "Green") {
        this.detailForm.grade = "A";
      } else if (val === "Amber") {
        this.detailForm.grade = "B";
      } else if (val === "Yellow") {
        this.detailForm.grade = "A";
      } else {
        this.detailForm.grade = "";
      }
    },
    // 上传发生变化钩子
    handleFileChange(file, fileList) {
      this.upload.fileList = fileList;
    },
    // 删除之前钩子
    handleFileRemove(file, fileList) {
      this.upload.fileList = fileList;
    },
    beforeUpload(file) {
      console.log("🚀 ~ file: MaintainScoreTask.vue ~ line 352 ~ beforeUpload ~ file", file)
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$my_message(this.$t("prompt.imageFileSize"), "error");
      }
      return isLt50M;
    },
    submitFileForm() {
      console.log('3333333333');
      // 创建新的数据对象
      let formData = new FormData();
      // 将上传的文件放到数据对象中
      this.upload.fileList.forEach(file => {
        formData.append('file', file.raw);
      });
      // 文件名
      fileService.sqmsFileUpload(formData, this.factorType, this.ttQspiFacilityFactorScoreId).then(res => {
        console.log("🚀 ~ file: MaintainScoreTask.vue ~ line 368 ~ fileService.sqmsFileUpload ~ res", res)
        this.getFileLists();
      })
    },
    uploadSuccess(response, file, fileList) {
      console.log("response", response);
      if (response.code === "200") {
        this.$message.success("上传成功");
        this.getFileLists();
      }
    },
    delFile(file, index) {
      console.log("file", file);
      if (file.tmDocumentId) {
        fileService.deleteFile(file.tmDocumentId).then((res) => {
          if (res.code === "200") {
            this.fileList.splice(index, 1);
            this.getFileLists();
          }
        });
      } else {
        this.fileList.splice(index, 1);
      }
    },
    scoreChange(val) {
      console.log("分数", val);
      if (val) {
        var reg = /^(0|\+?[1-9][0-9]*)$/;
        if (!reg.test(val)) {
          this.$message.error("分数只能输入大于等于0的整数");
          return false;
        }
        otherApi.findGradeToScore("OTHER", val).then((res) => {
          if (res.code === "200") {
            console.log("分数res", res);
            this.detailForm.grade = res.data;
          }
        });
      }
    },
    getFileLists() {
      QBRApi.getFileLists({
        tsReckindId: this.factorType,
        tsRecId: this.ttQspiFacilityFactorScoreId,
      }).then((res) => {
        console.log("获取列表", res);
        this.fileList = res;
      });
    },
    downloadFile(row) {
      fileService.downloadFile(row).then((res) => { });
    },
    onSave() {
      if (!this.isCanAudit) {
        this.$my_message(
          "您没有权限操作" +
          this.detailForm.month +
          "" +
          this.detailForm.category2Name +
          "" +
          this.detailForm.facilityName +
          " 的数据",
          "error"
        );
        return false;
      }
      // gy
      console.log("this.fileList.length", this.fileList);
      if (this.factorType === "SQMS" && this.fileList.length == 0) {
        this.$message.error("请上传附件");
        return false;
      }
      if (
        this.ms_Permission.indexOf("QSPI_MSV_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_SWA_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_SQMS_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_GOVTCERT_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_SPECCOMP_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_COA_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_REGCOMP_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_GOVTPLANT_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_OTHSTOCKRECOVER_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_PRDFEEDBACK_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_SENSORY_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_OTHQIP_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_ANTICHICK_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_OTHQBR_OWNER") !== -1
      ) {
        this.$refs["detailForm"].validate((valid) => {
          if (valid) {
            console.log(
              "this.detailForm.auditGrade",
              this.detailForm.auditGrade
            );
            var auditGrade = "";
            if (this.factorType === "SWA") {
              auditGrade = this.detailForm.auditGrade;
            } else {
              auditGrade = "";
            }
            console.log("auditGrade", auditGrade);
            otherApi
              .saveQspiScore({
                grade: this.detailForm.grade,
                score: this.detailForm.score,
                remark: this.detailForm.remark,
                ttQspiFacilityFactorScoreId: this.ttQspiFacilityFactorScoreId,
                month: this.detailForm.month,
                auditGrade: auditGrade,
              })
              .then((res) => {
                console.log("1111数据", res);
                if (res.code === "200") {
                  this.$message.success("保存成功");
                  this.$emit("closeDetailDialog");
                }
              });
          }
        });
      } else {
        var aaa = Date.parse(new Date());
        var bbb = Date.parse(new Date(this.detailForm.deadline));
        if (
          (this.ms_Permission.indexOf("QSPI_MSV_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SWA_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SQMS_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_GOVTCERT_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SPECCOMP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_COA_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_REGCOMP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_GOVTPLANT_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHSTOCKRECOVER_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_PRDFEEDBACK_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SENSORY_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHQIP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_ANTICHICK_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHQBR_SAVE") !== -1) &&
          aaa > bbb
        ) {
          this.$my_message(
            this.detailForm.month +
            " " +
            this.detailForm.category2Name +
            " " +
            this.detailForm.facilityName +
            " 已超过截止日期不能修改",
            "error"
          );
          return false;
        }
        if (
          (this.ms_Permission.indexOf("QSPI_MSV_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SWA_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SQMS_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_GOVTCERT_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SPECCOMP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_COA_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_REGCOMP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_GOVTPLANT_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHSTOCKRECOVER_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_PRDFEEDBACK_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SENSORY_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHQIP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_ANTICHICK_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHQBR_SAVE") !== -1) &&
          this.detailForm.status === "SCORED"
        ) {
          this.$my_message(
            this.detailForm.month +
            " " +
            this.detailForm.category2Name +
            " " +
            this.detailForm.facilityName +
            " 评分已提交不能修改",
            "error"
          );
          return false;
        }
        if (
          (this.ms_Permission.indexOf("QSPI_MSV_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SWA_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SQMS_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_GOVTCERT_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SPECCOMP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_COA_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_REGCOMP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_GOVTPLANT_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHSTOCKRECOVER_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_PRDFEEDBACK_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SENSORY_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHQIP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_ANTICHICK_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHQBR_SAVE") !== -1) &&
          this.detailForm.status === "SCORED" &&
          !this.detailForm.remark
        ) {
          this.$my_message(
            "请填写" +
            this.detailForm.month +
            " " +
            this.detailForm.category2Name +
            " " +
            this.detailForm.facilityName +
            "的Comment",
            "error"
          );
          return false;
        }
        this.$refs["detailForm"].validate((valid) => {
          if (valid) {
            console.log(
              "this.detailForm.auditGrade",
              this.detailForm.auditGrade
            );
            var auditGrade = "";
            if (this.factorType === "SWA") {
              auditGrade = this.detailForm.auditGrade;
            } else {
              auditGrade = "";
            }
            console.log("auditGrade", auditGrade);
            otherApi
              .saveQspiScore({
                grade: this.detailForm.grade,
                score: this.detailForm.score,
                remark: this.detailForm.remark,
                auditGrade: auditGrade,
                ttQspiFacilityFactorScoreId: this.ttQspiFacilityFactorScoreId,
                month: this.detailForm.month,
              })
              .then((res) => {
                console.log("1111数据", res);
                if (res.code === "200") {
                  this.$message.success("保存成功");
                  this.$emit("closeDetailDialog");
                }
              });
          }
        });
      }
    },
    onSubmit() {
      if (this.factorType === "SQMS" && this.fileList.length == 0) {
        this.$message.error("请上传附件");
        return false;
      }
      if (
        this.ms_Permission.indexOf("QSPI_MSV_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_SWA_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_SQMS_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_GOVTCERT_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_SPECCOMP_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_COA_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_REGCOMP_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_GOVTPLANT_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_OTHSTOCKRECOVER_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_PRDFEEDBACK_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_SENSORY_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_OTHQIP_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_ANTICHICK_OWNER") !== -1 ||
        this.ms_Permission.indexOf("QSPI_OTHQBR_OWNER") !== -1
      ) {
        this.$refs["detailForm"].validate((valid) => {
          if (valid) {
            otherApi
              .batchSubmit({
                factorType: this.factorType,
                grade: this.detailForm.grade,
                score: this.detailForm.score,
                remark: this.detailForm.remark,
                auditGrade:
                  this.factorType === "SWA" ? this.detailForm.auditGrade : "",
                ttQspiFacilityFactorScoreId: this.ttQspiFacilityFactorScoreId,
                month: this.detailForm.month,
              })
              .then((res) => {
                console.log("保存后提交", res);
                if (res.code === "200") {
                  this.$message.success("提交成功");
                  this.$emit("closeDetailDialog");
                }
              });
          }
        });
      } else {
        var aaa = Date.parse(new Date());
        var bbb = Date.parse(new Date(this.detailForm.deadline));
        if (
          (this.ms_Permission.indexOf("QSPI_MSV_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SWA_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SQMS_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_GOVTCERT_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SPECCOMP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_COA_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_REGCOMP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_GOVTPLANT_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHSTOCKRECOVER_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_PRDFEEDBACK_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SENSORY_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHQIP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_ANTICHICK_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHQBR_SAVE") !== -1) &&
          aaa > bbb
        ) {
          this.$my_message(
            this.detailForm.month +
            " " +
            this.detailForm.category2Name +
            " " +
            this.detailForm.facilityName +
            " 已超过截止日期不能修改",
            "error"
          );
          return false;
        }
        if (
          (this.ms_Permission.indexOf("QSPI_MSV_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SWA_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SQMS_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_GOVTCERT_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SPECCOMP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_COA_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_REGCOMP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_GOVTPLANT_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHSTOCKRECOVER_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_PRDFEEDBACK_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SENSORY_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHQIP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_ANTICHICK_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHQBR_SAVE") !== -1) &&
          this.detailForm.status === "SCORED"
        ) {
          this.$my_message(
            this.detailForm.month +
            " " +
            this.detailForm.category2Name +
            " " +
            this.detailForm.facilityName +
            " 评分已提交不能修改",
            "error"
          );
          return false;
        }
        if (
          (this.ms_Permission.indexOf("QSPI_MSV_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SWA_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SQMS_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_GOVTCERT_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SPECCOMP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_COA_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_REGCOMP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_GOVTPLANT_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHSTOCKRECOVER_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_PRDFEEDBACK_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_SENSORY_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHQIP_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_ANTICHICK_SAVE") !== -1 ||
            this.ms_Permission.indexOf("QSPI_OTHQBR_SAVE") !== -1) &&
          this.detailForm.status === "SCORED" &&
          !this.detailForm.remark
        ) {
          this.$my_message(
            "请填写" +
            this.detailForm.month +
            " " +
            this.detailForm.category2Name +
            " " +
            this.detailForm.facilityName +
            "的Comment",
            "error"
          );
          return false;
        }
        this.$refs["detailForm"].validate((valid) => {
          if (valid) {
            otherApi
              .batchSubmit({
                factorType: this.factorType,
                grade: this.detailForm.grade,
                score: this.detailForm.score,
                remark: this.detailForm.remark,
                auditGrade:
                  this.factorType === "SWA" ? this.detailForm.auditGrade : "",
                ttQspiFacilityFactorScoreId: this.ttQspiFacilityFactorScoreId,
                month: this.detailForm.month,
              })
              .then((res) => {
                console.log("保存后提交", res);
                if (res.code === "200") {
                  this.$message.success("提交成功");
                  this.$emit("closeDetailDialog");
                }
              });
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.el-card {
  margin-bottom: 1em !important;
}
</style>